<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div v-if="warning" class="form-field-warn" style="right: 0 !important;">
      <label>!</label>
      <div class="form-field-warn-text">
        <div>{{ warningText }}</div>
      </div>
    </div>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input-facade
      v-model="inputValue"
      masked
      :id="inputId"
      :mask="getDocumentMask(visitor)"
      :disabled="disabled"
      :placeholder="getDocumentHint(visitor)"
      :tokens="inputFacadeTokens"
      class="form-control text-uppercase"
      @change="emitValue('change', $event)"
      @input="emitValue('input', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'IdentificationNumberInput',

  components: { Hint },

  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],

  props: {
    inputLabel: {
      default: 'Серия и номер документа'
    },

    inputName: {
      default: 'identification_number'
    },

    inputHint: {
      default: undefined
    },

    documentMasks: {
      type: Array,
      default: () => []
    },

    warningMessage: {
      type: String,
      default: ''
    }
  },

  computed: {
    inputId() {
      let inputId = `form-visitor-identification-number-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-identification-number`
      }

      return inputId
    },

    showErrorBlock() {
      return ![
        ApplicationStatuses.AGENT_NO,
        ApplicationStatuses.FSB_NO,
        ApplicationStatuses.DISCARD,
        ApplicationStatuses.SB_NO,
        ApplicationStatuses.SUBDIVISION_NO
      ].includes(this.form.application.status)
    },

    inputFacadeTokens() {
      return {
        '#': { pattern: /\d/ },
        S: { pattern: /[a-zA-Z]/ },
        R: { pattern: /[А-Яа-я]/ },
        N: { pattern: /[I|V|X|C|D|M|L]/i },
        M: { pattern: /[0-9А-Яа-яa-zA-Z]/ }
      }
    },

    showWarning() {
      return this.isView && this.identificationNumberNeedCheck()
    },

    warning() {
      return (this.warningMessage && this.showErrorBlock) || this.showWarning
    },

    warningText() {
      const text = this.warningMessage ?? '';
      const showWarning = this.showWarning ? ' Неверная серия паспорта' : ''

      return text + showWarning
    }
  },

  methods: {
    getDocumentPatternData(visitor, type) {
      const result = this.documentMasks.find(mask => (Number(mask.nationality_id) === Number(visitor.personal.nationality_id) || mask.nationality_id == null) && mask.identification_id === visitor.personal.identification_id)

      return result && Object.prototype.hasOwnProperty.call(result, type) ? result[type] : null
    },

    getDocumentMask(visitor) {
      const documentMask = this.getDocumentPatternData(visitor, 'mask')
      let result = null

      if (documentMask) {
        result = documentMask
      }

      return result ? JSON.parse(result) : 'XXXXXXXXXXXXXXXX'
    },

    getDocumentHint(visitor) {
      const documentHint = this.getDocumentPatternData(visitor, 'hint')
      let result = ''

      if (documentHint) {
        result = documentHint
      }

      return result
    },

    identificationNumberNeedCheck() {
      let identificationNumber = this.inputValue

      if (identificationNumber?.length > 10 && this.russianCivilPassportSelected(this.visitor)) {
        let yearInSeries = identificationNumber.substring(2, 4)

        return this.checkPassportSeriesIsCorrect(yearInSeries)
      }

      return false
    }
  }
}
</script>
